export default function IconPlay() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M29.0375 14.2875L11.0375 3.29996C10.7377 3.10996 10.3914 3.00597 10.0365 2.99936C9.68161 2.99275 9.33171 3.08376 9.02501 3.26246C8.71377 3.43322 8.45432 3.68471 8.27394 3.99047C8.09356 4.29623 7.99893 4.64496 8.00001 4.99996V27C7.99893 27.355 8.09356 27.7037 8.27394 28.0094C8.45432 28.3152 8.71377 28.5667 9.02501 28.7375C9.33171 28.9162 9.68161 29.0072 10.0365 29.0006C10.3914 28.9939 10.7377 28.89 11.0375 28.7L29.0375 17.7125C29.3325 17.5345 29.5766 17.2833 29.746 16.9833C29.9154 16.6832 30.0044 16.3445 30.0044 16C30.0044 15.6554 29.9154 15.3167 29.746 15.0167C29.5766 14.7166 29.3325 14.4654 29.0375 14.2875Z"
        // fill="#1C1C1C"
        fill="rgba(155, 155, 155, 1)"
      />
    </svg>
  );
}
